/* AB ab_flex_offer — sunsets 2026-10-31, delete src/pages/AB_FlexOfferSuivi/ */

import { Box, paletteColors, Stack, Typography } from '@evaneos/b2b-ui';
import ArrowForwardIcon from '@evaneos/b2b-ui/icons/ArrowForward';
import { Link as RouterLink } from 'react-router-dom';

import { AB_FLEX_OFFER_SUIVI_PATH, useAB_FlexOfferEligible } from './AB_useFlexOfferEligible';

export function AB_FlexOfferHomepageCard() {
    const isEligible = useAB_FlexOfferEligible();

    if (!isEligible) {
        return null;
    }

    return (
        <Box
            component={RouterLink}
            to={AB_FLEX_OFFER_SUIVI_PATH}
            data-spec-id="flex-offer-homepage-card"
            sx={{
                display: 'block',
                textDecoration: 'none',
                color: 'inherit',
                padding: 2,
                borderRadius: 2,
                backgroundColor: paletteColors.green[100],
                border: `1px solid ${paletteColors.green[200]}`,
                marginBottom: 3,
                transition: 'background-color 0.15s ease',
                '&:hover': { backgroundColor: paletteColors.green[200] },
            }}
        >
            <Stack direction="row" alignItems="center" justifyContent="space-between" gap={2}>
                <Stack gap={0.5}>
                    <Typography
                        variant="subtitle1"
                        fontWeight={700}
                        color={paletteColors.green[800]}
                    >
                        Spring Flex Offer
                    </Typography>
                    <Typography variant="body2" color={paletteColors.green[800]}>
                        View your agency&apos;s booking tracker and key metrics.
                    </Typography>
                </Stack>
                <ArrowForwardIcon sx={{ color: paletteColors.green[800] }} />
            </Stack>
        </Box>
    );
}
